import { Component, effect, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme.service';
import { ToastContainerComponent } from './shared/components/toast-container/toast-container.component';
import { PopupContainerComponent } from './shared/components/popup/popup-container/popup-container.component';
import { ApplicationStore, ApplicationStoreType } from './core/store/application.store';
import { ActiveBroadcastsComponent } from './admin/broadcast/components/active-broadcasts/active-broadcasts.component';

@Component({
    selector: 'juyo-root',
    imports: [RouterOutlet, ToastContainerComponent, PopupContainerComponent, ActiveBroadcastsComponent],
    styleUrl: './app.scss',
    template: `
        <juyo-toast-container class="toasts"></juyo-toast-container>
        <juyo-popup-container></juyo-popup-container>
        <router-outlet />
        @if (showBroadcasts()) {
            <juyo-active-broadcasts />
        }
    `,
})
export class App {
    // load theme, do not remove
    private theme = inject(ThemeService);

    protected applicationStore: ApplicationStoreType = inject(ApplicationStore);

    protected showBroadcasts = signal<boolean>(false);

    constructor() {
        effect(() => {
            const user = this.applicationStore.signedInUser();
            const organization = this.applicationStore.selectedOrganization();

            if (user && organization) {
                this.showBroadcasts.set(true);
            }
        });
    }
}
